@if (addNewConfig) {
<div class="new-config">

  <div class="config-subheader px-3 py-3">
    <a href="javascript:void(0)" class="back-link d-flex align-items-center gap-2 text-decoration-none"
      (click)="onBack.emit()">
      <img src="/images/svg/back.svg" alt="back" style="width: 14px;">
      <span class="subheader-text">New Configuration</span>
    </a>
  </div>

  <div class="config-body px-3 scrollable-content">
    <div *ngIf="false" class="accordion-item border-0 mb-4">
      <div class="accordion-header d-flex justify-content-between align-items-center py-2">
        <span class="section-title">Service</span>
        <img src="/images/svg/dropdown.svg" alt="toggle" class="accordion-arrow">
      </div>

      <div class="services-cards mt-2 d-flex gap-3 overflow-auto pb-2">
        <div class="service-card text-center p-3 border rounded shadow-sm"
          *ngFor="let service of filterServices; let i = index" [class.active]="service.selected"
          (click)="selectService(i)">
          <div class="service-icon mb-2">
            <!-- <img [src]="'/images/svg/' + service.name.toLowerCase() + '.svg'" [alt]="service.name"
              onerror="this.src='/images/svg/gear.svg'" style="width: 24px; height: 24px;">
               -->
            <h6>{{service.name}}</h6>
          </div>
          <!-- <div class="service-price fw-bold">${{ (service.price || 12.99) | number: '1.2-2' }}</div> -->
        </div>
      </div>
    </div>

    <div class="accordion-item border-0 mb-4">
      <div class="accordion-header d-flex justify-content-between align-items-center py-2">
        <span class="section-title">Quantity</span>
        <img src="/images/svg/dropdown.svg" alt="toggle" class="accordion-arrow">
      </div>
      <div class="qty-control-wrapper mt-3">
        <div class="qty-control d-flex align-items-center border rounded" style="width: 100%;">
          <button class="qty-btn btn-trash border-0 bg-transparent p-2 border-end" (click)="minus()">
            <img src="/images/svg/mins.svg" alt="delete" style="width: 28px;">
          </button>
          <!-- <div class="qty-divider  mx-2" style="height: 28px;"></div> -->
          <h6 class="qty-value w-100 mb-0 text-center px-3 fw-bold">{{ qty }}</h6>
          <!-- <div class="qty-divider  mx-2" style="height: 28px;"></div> -->
          <button class="qty-btn btn-plus border-0 bg-transparent p-2 border-start" (click)="plus()">
            <img src="/images/svg/pls.svg" alt="plus" style="width: 28px;">
          </button>
        </div>
      </div>
    </div>
  </div>

  <div class="config-footer mt-auto border-top p-3 sticky-bottom bg-white shadow-lg">
    <div class="text-center mb-3">
      <a *ngIf="selectedProduct?.urlSlug" [routerLink]="['/product', selectedProduct.urlSlug]"
        class="view-details-link text-uppercase text-decoration-none fw-bold text-muted small"
        (click)="onBack.emit()">
        VIEW PRODUCT DETAILS
      </a>
    </div>

    <button class="btn-primary-config w-100 py-3 rounded text-uppercase fw-bold" (click)="addCartOptions()">
      ADD NEW CONFIGURATION
    </button>
  </div>
</div>
}
@else {
<div class="modal-content border-0" *ngIf="!openNotes">
  <div class="modal-header border-0">
    <h1 class="modal-title">Available S&F Services</h1>
    <button type="button" class="btn-close" (click)="modalRef.hide()"></button>
  </div>
  <div class="modal-body">
    <div class="services">
      <div class="upload-section">
        <ul class="p-0">
          <li *ngIf="selectedProduct.qty >= 1 && !serviceEdited && selectedProduct.options.length === 0"
            class="d-flex justify-content-between description">
            <p class="topQuantity">Choose The Item Qty To Add Services On</p>
            <div class="sort qty d-flex justify-content-between w-auto QuantityDiv">
              <div class="text m-0 d-flex justify-content-end align-items-center">
                <span (click)="minus()">
                  <img src="/images/svg/qty-minus.svg" alt="" />
                </span>
                <input type="text" [(ngModel)]="qty" />
                <span (click)="plus()">
                  <img src="/images/svg/qty-plus.svg" alt="" />
                </span>
              </div>
            </div>
          </li>
          <li>
            <div class="d-flex title justify-content-between">
              <p class="service pe-5">Service</p>
              <p class="qty ps-5">Qty</p>
              <p>Notes</p>
            </div>
          </li>
          <li *ngFor="let service of filterServices; let i = index">
            <div class="d-flex description justify-content-between">
              <p class="service">{{ service.name }}</p>
              <div class="sort qty mt-2" [ngStyle]="{
                  display: service.name === 'Punching' ? 'none' : 'block'
                }">
                <div class="text m-0 d-flex justify-content-start align-items-center">
                  <span (click)="handleOptionMinus(i)"><img src="/images/svg/qty-minus.svg" alt="" /></span>
                  <input type="text" [(ngModel)]="service.qty" />
                  <span (click)="handleOptionPlus(i)"><img src="/images/svg/qty-plus.svg" alt="" /></span>
                </div>
              </div>
              <p *ngIf="service.productOptionType !== 2" class="notes"
                (click)="openNotesModal(service); openNotes = true">
                Notes
              </p>
              <p *ngIf="service.productOptionType === 2" class="punch">
                <input type="checkbox" [(ngModel)]="service.Punching" />
              </p>
            </div>
          </li>

          <li *ngIf="showPdfOption">
            <div class="d-flex description justify-content-between" *ngIf="!fileUploaded">
              <p class="service">Drawing For Cutting Or Bending</p>
              <div class="d-flex align-items-center">
                <p class="notes addPdf" (click)="onAddPdf()">
                  Add PDF <img src="/images/svg/upload-pdf.svg" alt="" />
                </p>
                <input type="file" #fileInput style="display: none" (change)="onFileSelected($event)" />
              </div>
            </div>
            <div class="uploaded-pdf d-flex justify-content-between align-items-center" *ngIf="fileUploaded">
              <div class="d-flex align-items-center">
                <img src="/images/svg/pdf.svg" alt="pdf" />
                <p class="file-name mb-0">{{ filename }}</p>
              </div>
              <p class="remove mb-0" (click)="onClickRemovePDF()">Remove</p>
            </div>
          </li>
        </ul>
        <div class="selected-btn" (click)="addCartOptions()">
          <a data-bs-dismiss="modal" aria-label="Close" href="javascript:void">{{
            updateService ? "Update Services" : "Add Selected Services"
            }}</a>
        </div>
      </div>
    </div>
  </div>
</div>
<div class="modal-content" *ngIf="openNotes">
  <div class="modal-header">
    <h5 class="notes-title" id="exampleModalToggleLabel2">
      Add Notes for Slitting Service
    </h5>
    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"
      (click)="openNotes = false"></button>
  </div>
  <div class="modal-body">
    <div class="input-group mb-3">
      <textarea name="notes" style="height: 170px; width: 464px; padding: 5px" [(ngModel)]="tempNotes"
        placeholder="Enter additional details or special instructions here..."></textarea>
    </div>
    <div class="selected-btn mt-3">
      <a class="" (click)="saveNotes(); openNotes = false">Save Notes</a>
    </div>
  </div>
</div>
}
<!-- <div
  class="modal fade"
  id="exampleModalToggle2"
  aria-labelledby="exampleModalToggleLabel2"
  tabindex="-1"
>
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="notes-title" id="exampleModalToggleLabel2">
          Add Notes for Slitting Service
        </h5>
        <button 
          type="button"
          class="btn-close"
          data-bs-dismiss="modal"
          aria-label="Close"
        ></button>
      </div>
      <div class="modal-body">
        <div class="input-group mb-3">
          <textarea
            name="notes"
            style="height: 170px; width: 464px; padding: 5px"
            [(ngModel)]="tempNotes"
            placeholder="Enter additional details or special instructions here..."
          ></textarea>
        </div>
        <div class="selected-btn mt-3">
          <a
            class=""
            data-bs-target="#exampleModalToggle"
            data-bs-toggle="modal"
            data-bs-dismiss="modal"
            (click)="saveNotes()"
            >Save Notes</a
          >
        </div>
      </div>
    </div>
  </div>
</div> -->